import { render, staticRenderFns } from "./LeadRegistration.vue?vue&type=template&id=7b25f0a8&"
import script from "./LeadRegistration.vue?vue&type=script&lang=js&"
export * from "./LeadRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports